import s from '@/src/llm/Sidebar.module.scss';
import React, { createContext, useContext, useState } from 'react';
import clsx from 'clsx';

import { PhaseTimeline } from '@/src/llm/PhaseTimeline'; /* Been Here */
import { Commentary } from '@/src/llm/Commentary'; /* Been Here */
import { IProgramState } from '@/src/llm/Program'; /* Been Here */

import { IPhaseDef } from '@/src/llm/walkthrough/WalkthroughTools'; /* Been Here */

import { useSubscriptions } from '@/src/utils/hooks'; /* Been Here */


export const WalkthroughSidebar: React.FC = () => {
  let progState = useProgramState();
  let walkthrough = progState.walkthrough;
  let camera = progState.camera;
  let [menuVisible, setMenuVisible] = useState(false);
  let [menuButtonEl, setMenuButtonEl] = useState<HTMLElement | null>(null);

  function handlePhaseClick(ev: React.MouseEvent, phase: IPhaseDef) {
    if (walkthrough.phase !== phase.id) {
      walkthrough.phase = phase.id;
      walkthrough.time = 0;
      walkthrough.running = false;
      progState.markDirty();
    }

    setMenuVisible(false);
    ev.preventDefault();
  }

  function stepModel() {
    console.log('stepping model');
    progState.stepModel = true;
    progState.markDirty();
  }

  let menu = <>
    <div className={s.topSplit}>
      <div className={s.toc}>
        {walkthrough.phaseList.map((group, i) => {
          return <div key={group.groupId} className={s.phaseGroup}>
            <div className={s.phaseGroupTitle}>{group.title}</div>

            {group.phases.map((phase, j) => {
              let active = walkthrough.phase === phase.id;

              return <div key={phase.id} className={clsx(s.phase, active && s.active)} onClick={ev => handlePhaseClick(ev, phase)}>
                <div className={s.phaseTitle}>{phase.title}</div>
              </div>;
            })}
          </div>;
        })}
      </div>
    </div>
  </>;

  return <div className={s.walkthrough}>
    <div className={s.split}>
      <div className={s.timelineLeft}>
        <PhaseTimeline />
      </div>

      <div className={s.content}>
        <Commentary />
      </div>
    </div>
  </div>;
};


export let ProgramStateContext = createContext<IProgramState>(null!);


export function useProgramState() {
  let context = useContext(ProgramStateContext);
  useSubscriptions(context?.htmlSubs);

  return context;
}

/* Observed */